import { FC, memo } from 'react'

import { getRouteApi, useRouterState } from '@tanstack/react-router'
import { HistoryTable } from 'bank-entity-history'
import { TableDataQa } from 'commons/types/enums'
import { Dialog, DialogFace } from 'ui/components/Dialog'
import { AdverseMediaDetailsType } from '~bank-adverse-media/types/details'

interface Props {
  onClose: () => void
}

export const HistoryDialog: FC<Props> = memo(({ onClose }) => {
  const routerState = useRouterState()

  const routeApi = getRouteApi('/_app/adverse-media/$id')
  const loaderData = routeApi.useLoaderData({ select: (s) => s }) as AdverseMediaDetailsType

  const searchParams = routeApi.useSearch()
  const navigate = routeApi.useNavigate()

  const { historyPage, historySize } = searchParams

  return (
    <Dialog
      id="search-case-history"
      onClose={onClose}
      face={DialogFace.PRIMARY}
      title={loaderData.title}
      subTitle="Search Case History"
      headerStyle={{
        padding: '12px 40px'
      }}
      box="#adverse-general-information"
    >
      <HistoryTable
        dataQa={TableDataQa.BP_ADVERSE_MEDIA_SEARCH_CASE_HISTORY}
        items={loaderData.history}
        loading={routerState.status === 'pending'}
        pagination={{
          page: historyPage,
          size: historySize || 10,
          onChange: (page, size) => {
            navigate({ to: '.', search: (prev) => ({ ...prev, historyPage: page, historySize: size }) })
          },
          total: loaderData.historyTotalCount
        }}
      />
    </Dialog>
  )
})
